<div class="relative w-full h-full bg-proffeo-surface-muted overflow-hidden">
  @if (file()?.isImage()) {
    <!-- Fills the whole tile; other aspect ratios are cropped around the centre, leaving no empty bands. -->
    <img
      [src]="$safeNavigationMigration(file()?.previewUrl())"
      [alt]="$safeNavigationMigration(file()?.name)"
      loading="lazy"
      class="block w-full h-full object-cover object-center"
    />
  } @else if (file()?.isPdf()) {
    <div class="w-full h-full flex items-center justify-center file-thumbnail-pdf">
      <mat-icon
        fontIcon="picture_as_pdf"
        class="icon-xl icon-danger"
      />
    </div>
  } @else if (file()?.isVideo()) {
    <div class="w-full h-full flex items-center justify-center file-thumbnail-video">
      <mat-icon
        fontIcon="videocam"
        class="icon-xl icon-info"
      />
    </div>
  } @else {
    <div class="w-full h-full flex items-center justify-center file-thumbnail-document">
      <mat-icon
        fontIcon="description"
        class="icon-xl icon-disabled"
      />
    </div>
  }

  <!-- Avatar Badge -->
  @if (isAvatar()) {
    <div
      class="absolute top-2 right-2 bg-proffeo-success text-proffeo-on-action text-xs px-2 py-1 rounded-full flex items-center gap-1 shadow-lg"
    >
      <span>
        {{ 'files.files-list-is-avatar' | translate }}
      </span>
    </div>
  }
</div>
